import React from 'react';

const Cta = () => {
    return (
        <>
            {/* cta-section */}
            <section
                className="cta-section alternate-2 pb-240 centred"
                style={{ backgroundImage: 'url(assets/images/background/cta-1.jpg)' }}
            >
                <div className="auto-container">
                    <div className="inner-box clearfix" style={{ position: 'relative', zIndex: 10 }}>
                        <div className="text">
                            <h2>Looking to Rent a new property</h2>
                        </div>
                        <div className="btn-box d-flex justify-content-center gap-3">
                            <a href="/contact" style={{ 
                                display: 'inline-flex',
                                alignItems: 'center',
                                backgroundColor: '#ffffff', 
                                color: '#0a3d62', 
                                padding: '15px 35px', 
                                fontWeight: '700', 
                                fontSize: '1.05rem',
                                borderRadius: '6px', 
                                textDecoration: 'none', 
                                transition: 'all 0.3s cubic-bezier(0.165, 0.84, 0.44, 1)',
                                boxShadow: '0 8px 15px rgba(0, 0, 0, 0.1)',
                                position: 'relative',
                                zIndex: 10
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.background = '#f6f5f0';
                                e.currentTarget.style.transform = 'translateY(-3px)';
                                e.currentTarget.style.boxShadow = '0 12px 20px rgba(0, 0, 0, 0.15)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.background = '#ffffff';
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0 8px 15px rgba(0, 0, 0, 0.1)';
                            }}>
                                Free Consultation
                            </a>
                            <a href="/contact" style={{ 
                                display: 'inline-flex',
                                alignItems: 'center',
                                backgroundColor: '#25b579', 
                                color: '#ffffff', 
                                padding: '15px 35px', 
                                fontWeight: '700', 
                                fontSize: '1.05rem',
                                borderRadius: '6px', 
                                textDecoration: 'none', 
                                transition: 'all 0.3s cubic-bezier(0.165, 0.84, 0.44, 1)',
                                boxShadow: '0 8px 15px rgba(37, 181, 121, 0.2)',
                                position: 'relative',
                                zIndex: 10
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.background = '#1e9b67';
                                e.currentTarget.style.transform = 'translateY(-3px)';
                                e.currentTarget.style.boxShadow = '0 12px 20px rgba(37, 181, 121, 0.3)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.background = '#25b579';
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0 8px 15px rgba(37, 181, 121, 0.2)';
                            }}>
                                Get Free Valuation <i className="fas fa-arrow-right" style={{ marginLeft: '10px' }}></i>
                            </a>
                        </div>
                    </div>
                </div>
            </section>
            {/* cta-section end */}
        </>
    );
};

export default Cta;
